'use client';

import React, { useEffect } from "react";
import { loadEventsFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import { SlideOutEvent } from "@/app/lib/generated/graphql-types";
import FlyoutWrapper from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutWrapper";
import FlyoutHeaderTypography
    from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutHeaderTypography";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import { Stack } from "@mui/material";
import LinkButton from "@/app/features/shared/__to_be_integrated/LinkButton";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";

export default function EventsFlyoutInfo() {
    const [content, setContent] = React.useState<SlideOutEvent>();
    const [error, setError] = React.useState<string | null>(null);

    useEffect(() => {
        (async () => {
            const { data, error } = await loadEventsFlyoutContent();
            if (error || !data) {
                console.error('Error loading events flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
        })()
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            hideBackgroundOnMobile={false}
            backgroundImage={content.image}
            fit="fit"
        >
            <Stack
                spacing={2}
                sx={(theme) => ({
                    textAlign: 'center',
                    py: 2,
                    [theme.breakpoints.up('md')]: {
                        maxWidth: '33vw',
                        textAlign: 'left',
                    }
                })}
            >
                <FlyoutHeaderTypography>{content.title}</FlyoutHeaderTypography>
                <Markdown value={content.description}  />

                <Stack direction="row">
                    {content.links.filter(link => link !== null).map((link, index) => (
                        <LinkButton key={index} link={link} fullWidth />
                    ))}
                </Stack>
            </Stack>
        </FlyoutWrapper>
    )
}
